export default "__VITE_ASSET__2879b0fb__"